import { render, staticRenderFns } from "./page-header-part.vue?vue&type=template&id=ac3a3920&"
import script from "./page-header-part.vue?vue&type=script&lang=js&"
export * from "./page-header-part.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports